import { useEffect, useRef, type RefObject } from 'react';

/**
 * Keeps the last non-empty facets array across transient clears (e.g. refetch).
 * Facet membership for a list does not change, so create actions clicked mid-refetch
 * can still tell filters apart.
 */
export function useKnownFacets<T>(facets: T[] | null | undefined): RefObject<T[] | null | undefined> {
    const knownFacetsRef = useRef(facets);

    useEffect(() => {
        if (facets?.length) {
            knownFacetsRef.current = facets;
        }
    }, [facets]);

    return knownFacetsRef;
}
